export var SelectItemsQueryTypes;
(function (SelectItemsQueryTypes) {
    SelectItemsQueryTypes["Search"] = "Search";
    SelectItemsQueryTypes["ShowMore"] = "ShowMore";
})(SelectItemsQueryTypes || (SelectItemsQueryTypes = {}));
//# sourceMappingURL=types.js.map